import React, { useEffect, useState, useRef } from 'react';
import { Card, Modal, Row, Col, Input } from 'antd';
import { CSVLink } from "react-csv"; // Ensure you have react-csv installed for CSV downloads
import {VerifiedRounded} from "@mui/icons-material";
import Button from '@mui/material/Button';

const { Meta } = Card;



const handleAdvyzonExport = (dataSource) => {
  let rows = [['Ticker', 'Target']];
  dataSource.forEach(item => {
    let formattedWeight = (item.wgt * 100).toFixed(2) || 0;
    rows.push([item.symbol, formattedWeight]);
  });
  return rows;
};

const thirdPartyConfigs = [
  {
    title: "Advyzon",
    imgUrl: 'https://storage.googleapis.com/finiat-web-static-resources/third-party-brands/advyzon.png',
    onClick: handleAdvyzonExport
  }
  // You can add more configurations here
];

const ThirdPartyCard = ({ title, imgUrl, onClick, dataSource, setExportData }) => {
    const handleCardClick = () => {
        const formattedData = onClick(dataSource);
        setExportData(formattedData);
    };

    return (
        <Col span={12}>
            <Card
                bordered={false}
                hoverable
                cover={<img alt={title} src={imgUrl} />}
                onClick={handleCardClick}
            >
                <Meta title={title} />
            </Card>
        </Col>
    );
};

const ThirdPartyPortfolioExports = ({ dataSource, mode = 'modal' }) => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [fileName, setFileName] = useState("(RENAME EXPORT FILE).csv");
    const [csvData, setCsvData] = useState([]);
    const csvLink = useRef(null);

    useEffect(() => {
        if (csvData.length > 0) {
            csvLink.current.link.click();
        }
    }, [csvData]); // Trigger the download when csvData is updated

    const showModal = () => setIsModalVisible(true);
    const closeModal = () => setIsModalVisible(false);

    const setExportData = (data) => {
        setCsvData(data); // Update the state with the new data
    };

    const renderContent = () => (
        <>
            <Input placeholder="Enter file name" value={fileName.replace(".csv", "")} onChange={e => setFileName(e.target.value + ".csv")} style={{ marginBottom: 16 }} />
            <Row gutter={16}>
                {thirdPartyConfigs.map(config => (
                    <ThirdPartyCard
                        key={config.title}
                        title={config.title}
                        imgUrl={config.imgUrl}
                        onClick={config.onClick}
                        dataSource={dataSource}
                        setExportData={setExportData}
                    />
                ))}
            </Row>
        </>
    );

    return (
        <>
            {mode === 'modal' ? (
                <>
                    <Button startIcon={<VerifiedRounded/>} variant={'contained'} onClick={showModal}>
                        Export to 3rd Party
                    </Button>
                    <Modal
                        title="Export to Third Party"
                        visible={isModalVisible}
                        onCancel={closeModal}
                        footer={null}
                    >
                        <div className='p-3'>
                            {renderContent()}
                            <CSVLink
                                data={csvData}
                                filename={fileName}
                                ref={csvLink}
                                target="_blank"
                                style={{ display: 'none' }} // Ensuring the link is not visible
                            />
                        </div>
                    </Modal>
                </>
            ) : (
                <div>
                    {renderContent()}
                    <CSVLink
                        data={csvData}
                        filename={fileName}
                        ref={csvLink}
                        target="_blank"
                        style={{ display: 'none' }} // Ensuring the link is not visible
                    />
                </div>
            )}
        </>
    );
};

export default ThirdPartyPortfolioExports;
